import ApiRequestManagerInstance from '../ApiRequestManager';
import DateUtils from '../../utils/date';
import Rail from '../../classes/rail';
import { ILastShowsChannelRequest } from '../../types/interfaces/rail';
import { RailDisplayMode } from '../../types/enums/rail';
import { store } from '../../store/store';

function lastShowsChannel(channelCode: string, channelId: string) {
  const promise = new Promise<Rail[]>(async (resolve, reject) => {
    try {
      const { user } = store.getState();
      const response: ILastShowsChannelRequest =
        (await ApiRequestManagerInstance.get({
          endpoint: {
            url: user.isAnonymous ? 'cdnSyncUrl' : 'apiUrl',
            version: user.isAnonymous ? undefined : 'v4',
            section: user.isAnonymous ? 'mediafree' : 'media',
            subsection: user.isAnonymous ? 'u7dchannel' : 'lastShowsChannel',
            type: user.isAnonymous ? 'u7dchannel' : 'lastShowsChannel',
            replacement: user.isAnonymous ? channelCode : channelId,
          },
        })) as unknown as ILastShowsChannelRequest;

      const rails = response.data.map((item, index) => {
        const request = {
          section: {
            title: DateUtils.getTime({
              customDate: Date.parse(item.date),
              displaySeconds: false,
              displayMinutes: false,
              displayHours: false,
              displayDay: true,
              displayDayOfWeek: true,
              separator: ' ',
              utc: true,
            }),
            presentationType: RailDisplayMode.PHOTO,
            id: 'LastShows' + index,
            name: 'LastShows' + index,
          },
          shows: {
            data: item.shows,
          },
        };
        return new Rail(request);
      });
      resolve(rails);
    } catch (e) {
      console.error(e);
      reject([]);
    }
  });

  return promise;
}

export default lastShowsChannel;
